import { db } from '../../firebase';

export const startApplyBidTemplate = (bidId, type) => {
  return (dispatch) => {
    switch (type) {
      case "estimate":
        return db.createBidTemplateEstimate(bidId);
      case "maintenance":
        return db.createBidTemplateMaintenance(bidId);
      case "quote":
        return db.createBidTemplateQuote(bidId);
      default:
        return null;
    }
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/bidTemplates.js